import { render, staticRenderFns } from "./importWorkflowForm.vue?vue&type=template&id=b18ac9de&"
import script from "./importWorkflowForm.vue?vue&type=script&lang=js&"
export * from "./importWorkflowForm.vue?vue&type=script&lang=js&"
import style0 from "./importWorkflowForm.vue?vue&type=style&index=0&id=b18ac9de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports